// // import { Search, X, ChevronDown } from "lucide-react";
// // import { useMemo, useRef, useState, useEffect } from "react";
// // import {
// //   DATE_OPTIONS,
// //   getUniqueCategories,
// //   getUniqueTags,
// // } from "../data/KnowledgeFilters";

// // /* small reusable multi-select chip dropdown (categories / tags) */
// // function ChipDropdown({ label, options, selected, onToggle }) {
// //   const [open, setOpen] = useState(false);
// //   const ref = useRef(null);

// //   useEffect(() => {
// //     function onClick(e) {
// //       if (ref.current && !ref.current.contains(e.target)) setOpen(false);
// //     }
// //     document.addEventListener("mousedown", onClick);
// //     return () => document.removeEventListener("mousedown", onClick);
// //   }, []);

// //   if (!options.length) return null;

// //   return (
// //     <div className="relative" ref={ref}>
// //       <button
// //         type="button"
// //         onClick={() => setOpen((v) => !v)}
// //         className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[12.5px] font-bold ring-1 transition-colors ${
// //           selected.length
// //             ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent"
// //             : "bg-white text-ink/70 ring-ink/15 hover:text-brand hover:ring-brand"
// //         }`}
// //       >
// //         {label}
// //         {selected.length > 0 && (
// //           <span className="rounded-full bg-white/25 px-1.5 py-0.5 text-[10.5px]">
// //             {selected.length}
// //           </span>
// //         )}
// //         <ChevronDown className="w-3.5 h-3.5" />
// //       </button>

// //       {open && (
// //         <div className="absolute left-0 z-30 mt-2 w-56 max-h-64 overflow-auto rounded-xl bg-white p-2 shadow-xl ring-1 ring-ink/10">
// //           {options.map((opt) => {
// //             const active = selected.includes(opt);
// //             return (
// //               <button
// //                 key={opt}
// //                 type="button"
// //                 onClick={() => onToggle(opt)}
// //                 className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-[12.5px] font-semibold transition-colors ${
// //                   active ? "bg-blush text-deeprose" : "text-ink/70 hover:bg-cream"
// //                 }`}
// //               >
// //                 {opt}
// //                 {active && <span className="text-brand">✓</span>}
// //               </button>
// //             );
// //           })}
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default function KnowledgeFilterBar({ items, filters, setFilters, onSearch }) {
// //   const categories = useMemo(() => getUniqueCategories(items), [items]);
// //   const tags = useMemo(() => getUniqueTags(items), [items]);

// //   const toggleCategory = (cat) =>
// //     setFilters((f) => ({
// //       ...f,
// //       categories: f.categories.includes(cat)
// //         ? f.categories.filter((c) => c !== cat)
// //         : [...f.categories, cat],
// //     }));

// //   const toggleTag = (tag) =>
// //     setFilters((f) => ({
// //       ...f,
// //       tags: f.tags.includes(tag) ? f.tags.filter((t) => t !== tag) : [...f.tags, tag],
// //     }));

// //   return (
// //     <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
// //       {/* keyword */}
// //       <div className="flex flex-1 min-w-[200px] items-center gap-2 rounded-full bg-cream px-4 py-2.5 ring-1 ring-ink/10">
// //         <Search className="w-4 h-4 text-ink/50 flex-none" />
// //         <input
// //           type="text"
// //           value={filters.keyword}
// //           onChange={(e) => setFilters((f) => ({ ...f, keyword: e.target.value }))}
// //           onKeyDown={(e) => e.key === "Enter" && onSearch?.()}
// //           placeholder="Search title or description..."
// //           className="w-full bg-transparent text-[13px] text-ink placeholder:text-mute focus:outline-none"
// //         />
// //         {filters.keyword && (
// //           <button
// //             onClick={() => setFilters((f) => ({ ...f, keyword: "" }))}
// //             className="flex-none text-ink/40 hover:text-brand"
// //           >
// //             <X className="w-3.5 h-3.5" />
// //           </button>
// //         )}
// //       </div>

// //       <ChipDropdown
// //         label="States"
// //         options={categories}
// //         selected={filters.categories}
// //         onToggle={toggleCategory}
// //       />

// //       <ChipDropdown label="Tags" options={tags} selected={filters.tags} onToggle={toggleTag} />

// //       {/* date */}
// //       <div className="relative">
// //         <select
// //           value={filters.date}
// //           onChange={(e) => setFilters((f) => ({ ...f, date: e.target.value }))}
// //           className={`appearance-none rounded-full pl-4 pr-8 py-2 text-[12.5px] font-bold ring-1 transition-colors cursor-pointer ${
// //             filters.date
// //               ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent"
// //               : "bg-white text-ink/70 ring-ink/15 hover:text-brand hover:ring-brand"
// //           }`}
// //         >
// //           <option value="">Any time</option>
// //           {DATE_OPTIONS.map((o) => (
// //             <option key={o.value} value={o.value} className="text-ink">
// //               {o.label}
// //             </option>
// //           ))}
// //         </select>
// //         <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-current opacity-70" />
// //       </div>

// //       <button
// //         type="button"
// //         onClick={onSearch}
// //         className="rounded-full bg-gradient-to-r from-crimson to-deeprose text-white text-[12.5px] font-extrabold px-5 py-2.5 shadow-lg shadow-brand/30 hover:shadow-brand/50 transition-all"
// //       >
// //         Search
// //       </button>
// //     </div>
// //   );
// // }







// // new new code 





// import { Search, X, ChevronDown } from "lucide-react";
// import { useMemo, useRef, useState, useEffect } from "react";
// import {
//   DATE_OPTIONS,
//   getUniqueCategories,
//   getUniqueTags,
// } from "../data/KnowledgeFilters";

// /* small reusable multi-select chip dropdown (categories / tags) */
// function ChipDropdown({ label, options, selected, onToggle }) {
//   const [open, setOpen] = useState(false);
//   const ref = useRef(null);

//   useEffect(() => {
//     function onClick(e) {
//       if (ref.current && !ref.current.contains(e.target)) setOpen(false);
//     }
//     document.addEventListener("mousedown", onClick);
//     return () => document.removeEventListener("mousedown", onClick);
//   }, []);

//   if (!options.length) return null;

//   return (
//     <div className="relative" ref={ref}>
//       <button
//         type="button"
//         onClick={() => setOpen((v) => !v)}
//         className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[12.5px] font-bold ring-1 transition-colors ${
//           selected.length
//             ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent"
//             : "bg-white text-ink/70 ring-ink/15 hover:text-brand hover:ring-brand"
//         }`}
//       >
//         {label}
//         {selected.length > 0 && (
//           <span className="rounded-full bg-white/25 px-1.5 py-0.5 text-[10.5px]">
//             {selected.length}
//           </span>
//         )}
//         <ChevronDown className="w-3.5 h-3.5" />
//       </button>

//       {open && (
//         <div className="absolute left-0 z-30 mt-2 w-56 max-h-64 overflow-auto rounded-xl bg-white p-2 shadow-xl ring-1 ring-ink/10">
//           {options.map((opt) => {
//             const active = selected.includes(opt);
//             return (
//               <button
//                 key={opt}
//                 type="button"
//                 onClick={() => onToggle(opt)}
//                 className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-[12.5px] font-semibold transition-colors ${
//                   active ? "bg-blush text-deeprose" : "text-ink/70 hover:bg-cream"
//                 }`}
//               >
//                 {opt}
//                 {active && <span className="text-brand">✓</span>}
//               </button>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }

// export default function KnowledgeFilterBar({
//   items,
//   filters,
//   setFilters,
//   onSearch,
//   showSectorFilter = false,
// }) {
//   const categories = useMemo(() => getUniqueCategories(items), [items]);
//   const tags = useMemo(() => getUniqueTags(items), [items]);

//   const toggleCategory = (cat) =>
//     setFilters((f) => ({
//       ...f,
//       categories: f.categories.includes(cat)
//         ? f.categories.filter((c) => c !== cat)
//         : [...f.categories, cat],
//     }));

//   const toggleTag = (tag) =>
//     setFilters((f) => ({
//       ...f,
//       tags: f.tags.includes(tag) ? f.tags.filter((t) => t !== tag) : [...f.tags, tag],
//     }));

//   return (
//     <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
//       {/* keyword */}
//       <div className="flex flex-1 min-w-[200px] items-center gap-2 rounded-full bg-cream px-4 py-2.5 ring-1 ring-ink/10">
//         <Search className="w-4 h-4 text-ink/50 flex-none" />
//         <input
//           type="text"
//           value={filters.keyword}
//           onChange={(e) => setFilters((f) => ({ ...f, keyword: e.target.value }))}
//           onKeyDown={(e) => e.key === "Enter" && onSearch?.()}
//           placeholder="Search title or description..."
//           className="w-full bg-transparent text-[13px] text-ink placeholder:text-mute focus:outline-none"
//         />
//         {filters.keyword && (
//           <button
//             onClick={() => setFilters((f) => ({ ...f, keyword: "" }))}
//             className="flex-none text-ink/40 hover:text-brand"
//           >
//             <X className="w-3.5 h-3.5" />
//           </button>
//         )}
//       </div>

//       {showSectorFilter && (
//         <ChipDropdown
//           label="States"
//           options={categories}
//           selected={filters.categories}
//           onToggle={toggleCategory}
//         />
//       )}

//       <ChipDropdown label="Tags" options={tags} selected={filters.tags} onToggle={toggleTag} />

//       {/* date */}
//       <div className="relative">
//         <select
//           value={filters.date}
//           onChange={(e) => setFilters((f) => ({ ...f, date: e.target.value }))}
//           className={`appearance-none rounded-full pl-4 pr-8 py-2 text-[12.5px] font-bold ring-1 transition-colors cursor-pointer ${
//             filters.date
//               ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent"
//               : "bg-white text-ink/70 ring-ink/15 hover:text-brand hover:ring-brand"
//           }`}
//         >
//           <option value="">Any time</option>
//           {DATE_OPTIONS.map((o) => (
//             <option key={o.value} value={o.value} className="text-ink">
//               {o.label}
//             </option>
//           ))}
//         </select>
//         <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-current opacity-70" />
//       </div>

//       <button
//         type="button"
//         onClick={onSearch}
//         className="rounded-full bg-gradient-to-r from-crimson to-deeprose text-white text-[12.5px] font-extrabold px-5 py-2.5 shadow-lg shadow-brand/30 hover:shadow-brand/50 transition-all"
//       >
//         Search
//       </button>
//     </div>
//   );
// }







// new code 









import { Search, X, ChevronDown } from "lucide-react";
import { useMemo, useState } from "react";
import {
  DATE_OPTIONS,
  getUniqueCategories,
  getUniqueTags,
} from "../data/KnowledgeFilters";

/* vertical checklist group used inside the sidebar (sectors / tags) */
function FilterGroup({ title, options, selected, onToggle }) {
  const [open, setOpen] = useState(true);

  if (!options.length) return null;

  return (
    <div className="border-t border-ink/10 pt-4 first:border-t-0 first:pt-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between text-left"
      >
        <span className="text-[11px] font-extrabold uppercase tracking-wider text-mute">
          {title}
          {selected.length > 0 && ` (${selected.length})`}
        </span>
        <ChevronDown
          className={`w-3.5 h-3.5 text-mute transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-3 flex flex-col gap-1 max-h-56 overflow-auto pr-1">
          {options.map((opt) => {
            const active = selected.includes(opt);
            return (
              <label
                key={opt}
                className="flex items-center gap-2 rounded-lg px-2 py-1.5 text-[12.5px] font-semibold cursor-pointer hover:bg-cream"
              >
                <input
                  type="checkbox"
                  checked={active}
                  onChange={() => onToggle(opt)}
                  className="h-3.5 w-3.5 accent-[#DA2128]"
                />
                <span className={active ? "text-deeprose" : "text-ink/70"}>{opt}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function KnowledgeFilterBar({
  items,
  filters,
  setFilters,
  onSearch,
  showSectorFilter = false,
}) {
  const categories = useMemo(() => getUniqueCategories(items), [items]);
  const tags = useMemo(() => getUniqueTags(items), [items]);

  const toggleCategory = (cat) =>
    setFilters((f) => ({
      ...f,
      categories: f.categories.includes(cat)
        ? f.categories.filter((c) => c !== cat)
        : [...f.categories, cat],
    }));

  const toggleTag = (tag) =>
    setFilters((f) => ({
      ...f,
      tags: f.tags.includes(tag) ? f.tags.filter((t) => t !== tag) : [...f.tags, tag],
    }));

  return (
    <div className="flex flex-col gap-5">
      {/* keyword */}
      <div className="flex items-center gap-2 rounded-full bg-cream px-4 py-2.5 ring-1 ring-ink/10">
        <Search className="w-4 h-4 text-ink/50 flex-none" />
        <input
          type="text"
          value={filters.keyword}
          onChange={(e) => setFilters((f) => ({ ...f, keyword: e.target.value }))}
          onKeyDown={(e) => e.key === "Enter" && onSearch?.()}
          placeholder="Search title or description..."
          className="w-full bg-transparent text-[13px] text-ink placeholder:text-mute focus:outline-none"
        />
        {filters.keyword && (
          <button
            onClick={() => setFilters((f) => ({ ...f, keyword: "" }))}
            className="flex-none text-ink/40 hover:text-brand"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {showSectorFilter && (
        <FilterGroup
          title="States"
          options={categories}
          selected={filters.categories}
          onToggle={toggleCategory}
        />
      )}

      <FilterGroup title="Tags" options={tags} selected={filters.tags} onToggle={toggleTag} />

      {/* date */}
      <div className="border-t border-ink/10 pt-4">
        <p className="mb-3 text-[11px] font-extrabold uppercase tracking-wider text-mute">
          Date
        </p>
        <div className="flex flex-col gap-1">
          <button
            type="button"
            onClick={() => setFilters((f) => ({ ...f, date: "" }))}
            className={`rounded-lg px-2.5 py-1.5 text-left text-[12.5px] font-semibold transition-colors ${
              !filters.date ? "bg-blush text-deeprose" : "text-ink/70 hover:bg-cream"
            }`}
          >
            Any time
          </button>
          {DATE_OPTIONS.map((o) => (
            <button
              key={o.value}
              type="button"
              onClick={() => setFilters((f) => ({ ...f, date: o.value }))}
              className={`rounded-lg px-2.5 py-1.5 text-left text-[12.5px] font-semibold transition-colors ${
                filters.date === o.value ? "bg-blush text-deeprose" : "text-ink/70 hover:bg-cream"
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onSearch}
        className="w-full rounded-full bg-gradient-to-r from-crimson to-deeprose text-white text-[12.5px] font-extrabold px-5 py-2.5 shadow-lg shadow-brand/30 hover:shadow-brand/50 transition-all"
      >
        Search
      </button>
    </div>
  );
}